import React, { Fragment } from "react";
import { Tag, Tooltip, Divider, Space, Popover, Popconfirm } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Helpers from "@Apis/helpers";
import { toISTDate } from "@Apis/constants";
import ZohoBooks from "@Images/admin/integrations/zoho-books.png";
import TallyPrime from "@Images/admin/integrations/tally-prime.png";
import PRZText from "../../../../../Common/UI/PRZText";
import HideValue from "../../../../../Common/RestrictedAccess/HideValue";
import H3Text from "../../../../../../uilib/h3Text";
import ViewTableCustomFields from "@Components/Common/CustomField/ViewTableCustomFields";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";

const AccountPayableInvoiceListTableColumns = ({
  isMobile,
  visibleColumns,
  customFieldsProps,
  user,
  priceMasking,
  MONEY,
  isPortrait,
  setMoreDetailsDrawer,
  setSelectedAPInvoice,
}) => {
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } =
    priceMasking;
  const colorArray = [
    "blue",
    "red",
    "geekblue",
    "green",
    "volcano",
    "orange",
    "cyan",
    "purple",
    "blue",
    "red",
    "geekblue",
    "green",
    "volcano",
    "orange",
    "cyan",
    "purple",
  ];
  const apinvoiceColumnsList = [
    {
      title: "",
      render: (record) => {
        function showApInvoiceType() {
          if (record?.linked_grns?.length > 0) {
            return "GRN";
          } else {
            return "ADHOC";
          }
        }
        return (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText
                  className="mobile-list__card_item-number"
                  text={`#${record?.grn_number ? record.grn_number : "N/A"}`}
                />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{
                    backgroundColor: Helpers.getStatusColor(record.status)
                      .color,
                  }}
                  text={Helpers.getStatusColor(
                    record.status
                  ).text?.toProperCase()}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Link
                    to={`/vendors/view/${record?.seller_info?.seller_id}`}
                    target="_blank"
                  >
                    <PRZText
                      className="mobile-list__card_item-name"
                      text={
                        record && record.tenant_seller_info
                          ? `${record?.internal_slr_code
                              ? `${record?.internal_slr_code} - `
                              : ""
                            }${record.tenant_seller_info?.seller_name}`?.trim()
                          : ""
                      }
                    />
                  </Link>
                </div>
                <PRZText
                  text={`Location - ${record?.tenant_name} (${record?.department_name || "N/A"
                    })`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Account Payable Invoice Date - ${toISTDate(
                    record?.grn_date_time
                  ).format("DD/MM/YYYY")}`}
                  className="mobile-list__card_item-details"
                />
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color"
                      text="Grand Total"
                    />
                  }
                >
                  <PRZText
                    text={
                      isDataMaskingPolicyEnable && isHideCostPrice ? (
                        <HideValue
                          showPopOver
                          popOverMessage="You don't have access to view grand total"
                        />
                      ) : (
                        MONEY(
                          record.grn_grand_total || "0",
                          record?.currency_code
                        )
                      )
                    }
                  />
                </Tooltip>
                <Tooltip
                  color="white"
                  placement="top"
                  title={
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color"
                      text="Total Due"
                    />
                  }
                >
                  <PRZText
                    text={
                      isDataMaskingPolicyEnable && isHideCostPrice ? (
                        <HideValue
                          showPopOver
                          popOverMessage="You don't have access to view total due"
                        />
                      ) : (
                        // MONEY(
                        //   (record?.grn_grand_total || 0) -
                        //     (record?.total_payment_made || 0) -
                        //     (record
                        //       ? Helpers.getValueTotalInObject(
                        //           record?.debit_note_info,
                        //           "document_db_total"
                        //         )
                        //       : Helpers.getValueTotalInObject(
                        //           record?.debit_note_info,
                        //           "db_total"
                        //         )),
                        //   record?.currency_code
                        // )
                        MONEY((record?.grand_total - (Helpers.getValueTotalInObject(record?.debit_note_info, 'document_db_total') || Helpers.getValueTotalInObject(record?.debit_note_info, 'db_total')) - record?.total_payment_made), record?.org_currency_info?.currency_code)
                      )
                    }
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  title={
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text="GRN Type"
                    />
                  }
                  color="white"
                >
                  <div
                    className="qr__status"
                    style={{
                      backgroundColor: "rgb(28, 123, 225)",
                      fontSize: "10px",
                      padding: "1px 6px",
                    }}
                  >
                    {`${showApInvoiceType()}`}
                  </div>
                </Tooltip>
                {/* <div className="mobile-list__card_footer__actions-button_wrapper"> */}
                <div className="display-none">
                  {user?.user_tenants?.find(
                    (item) => item?.tenant_id === record?.tenant_id
                  )?.zoho_branch_id && (
                      <div className="card_footer__actions-button">
                        <Fragment>
                          {["GOOD_RECEIVING_NOTE", "PURCHASE_ORDER"].includes(
                            record.grn_entity_type
                          ) &&
                            record?.status === "ISSUED" &&
                            user?.user_tenants?.find(
                              (item) => item?.tenant_id === record?.tenant_id
                            )?.zoho_branch_idz && (
                              <div>
                                {record?.zoho_bill_id ? (
                                  <Tooltip
                                    title={toISTDate(
                                      record?.zoho_updated_at
                                    ).format("DD/MM/YYYY hh:mm A")}
                                    overlayClassName="font-12"
                                    placement="topRight"
                                  >
                                    <a
                                      href={`https://books.zoho.in/app#/bills/${record?.zoho_bill_id}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                        <img
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                          src={ZohoBooks}
                                          alt="Zoho"
                                          className="img-zoho card_footer__actions-button_image"
                                        />
                                        <div className="green-indicator" />
                                      </div>
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <Popconfirm
                                    title={
                                      record?.zoho_warning_message === null ||
                                        record?.zoho_warning_message === ""
                                        ? "This GRN is not synced with Zoho Books."
                                        : `${record?.zoho_warning_message}`
                                    }
                                    onConfirm={() => {
                                      if (!syncGRNLoading) {
                                        syncGRN({ grn_id: record?.grn_id }, () =>
                                          getGRN(user?.tenant_info?.tenant_id, null, null, null, "", limit, currentPage, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true),
                                        );
                                      }
                                    }}
                                    okText="Sync again"
                                    okButtonProps={{
                                      loading: syncGRNLoading,
                                    }}
                                    cancelText="Cancel"
                                  >
                                    <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        style={{
                                          width: "18px",
                                          height: "18px",
                                        }}
                                        src={ZohoBooks}
                                        alt="Zoho"
                                        className="img-zoho img-zoho__disabled card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator red-indicator" />
                                    </div>
                                  </Popconfirm>
                                )}
                              </div>
                            )}
                        </Fragment>
                      </div>
                    )}
                  {user?.user_tenants?.find(
                    (item) => item?.tenant_id === record?.tenant_id
                  )?.tally_configuration?.purchase_voucher_integration && (
                      <div className="card_footer__actions-button">
                        <Fragment>
                          {record.grn_entity_type !== "INVENTORY_TRANSFER" &&
                            record?.status === "ISSUED" &&
                            user?.user_tenants?.find(
                              (item) => item?.tenant_id === record?.tenant_id
                            )?.tally_company_name && (
                              <div>
                                {record?.tally_updated_at ? (
                                  <Tooltip
                                    title={`Last updated at ${toISTDate(
                                      record?.tally_updated_at
                                    ).format("DD/MM/YYYY hh:mm A")}`}
                                    overlayClassName="font-12"
                                    placement="topRight"
                                  >
                                    <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        src={TallyPrime}
                                        alt="Tally"
                                        className="img-tally card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator" />
                                    </div>
                                  </Tooltip>
                                ) : (
                                  <Popconfirm
                                    title={
                                      record?.tally_warning_message ||
                                      "This GRN is not synced with Tally."
                                    }
                                    onConfirm={() =>
                                      syncTallyGRN(
                                        { grn_id: record?.grn_id },
                                        () =>
                                          getGRN(user?.tenant_info?.tenant_id, null, null, null, "", limit, currentPage, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true),
                                      )
                                    }
                                    okText="Sync again"
                                    okButtonProps={{
                                      // loading: syncTallyGRNLoading,
                                      loading: false,
                                    }}
                                    cancelText="Cancel"
                                  >
                                    <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        src={TallyPrime}
                                        alt="Tally"
                                        className="img-tally img-tally__disabled card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator red-indicator" />
                                    </div>
                                  </Popconfirm>
                                )}
                              </div>
                            )}
                        </Fragment>
                      </div>
                    )}
                  {record?.is_busy_connected && (
                    <div className="card_footer__actions-button">
                      {["ISSUED"].includes(record.status) && (
                        <div>
                          {" "}
                          {record?.busy_sync_at ? (
                            <Tooltip
                              title={`Last updated at ${toISTDate(
                                record?.busy_sync_at
                              ).format("DD/MM/YYYY hh:mm A")}`}
                              overlayClassName="font-12"
                              placement="topRight"
                            >
                              <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                <img
                                  src={Busy}
                                  alt="Tally"
                                  className="img-tally card_footer__actions-button_image"
                                />
                                <div className="green-indicator" />
                              </div>
                            </Tooltip>
                          ) : (
                            <Popconfirm
                              title={
                                record?.busy_sync_error ||
                                "This GRN is not synced with Busy."
                              }
                              onConfirm={() =>
                                pushGrnToBusy({ grn_id: record?.grn_id }, () =>
                                  getGRN(
                                    user?.tenant_info?.tenant_id,
                                    null,
                                    null,
                                    null,
                                    "",
                                    limit,
                                    currentPage,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    true
                                  )
                                )
                              }
                              okText="Sync again"
                              okButtonProps={{
                                loading: pushGrnToBusyLoading,
                              }}
                              cancelText="Cancel"
                            >
                              <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                <img
                                  src={Busy}
                                  alt="Tally"
                                  className="img-tally card_footer__actions-button_image"
                                />
                                <div className="green-indicator red-indicator" />
                              </div>
                            </Popconfirm>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedAPInvoice(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">
                        More Info
                      </span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  }
                />
              </div>
            </div>
          </div>
        );
      },
      // responsive: ['xs'],
      hidden: !isMobile,
    },
    {
      title: "AP Invoice #",
      render: (record) => {
        function showApInvoiceType() {
          if (record?.linked_grns?.length > 0) {
            return "GRN";
          } else {
            return "ADHOC";
          }
        }
        return (
          <div className="min-width-50">
            <H3Text text={record?.ap_invoice_number} />
            <div
              className="qr__status"
              style={{
                backgroundColor: "rgb(28, 123, 225)",
                fontSize: "10px",
                padding: "1px 6px",
              }}
            >
              {`${showApInvoiceType()}`}
            </div>
          </div>
        );
      },
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      fixed: "left",
      className: !visibleColumns?.AP_INVOICE_NUMBER?.visible
        ? "display-none"
        : "",
    },
    {
      title: "LOCATION",
      render: (record) => (
        <div className="min-width-70">
          <H3Text text={record?.tenant_name} />
          <H3Text text={record?.department_name} className="table-subscript" />
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.LOCATION.visible ? "display-none" : "",
    },
    {
      title: "VENDOR",
      dataIndex: "tenant_seller_info",
      render: (text, record) => (
        <div className="min-width-70">
          {record?.seller_name ? (
            <div className="associated-entity">
              <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                {`${record?.internal_slr_code
                    ? `${record?.internal_slr_code} - `
                    : ""
                  }${record?.seller_name}`?.trim()}
              </Link>
            </div>
          ) : (
            "-"
          )}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.VENDOR?.visible ? "display-none" : "",
    },
    {
      title: "VENDOR INVOICE #",
      dataIndex: "vendor_invoice_number",
      render: (text, record) => (
        <div
          style={{
            color: "rgb(87, 90, 87)",
          }}
          className="min-width-100"
        >
          {record?.vendor_invoice_number || "-"}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.VENDOR_INVOICE?.visible ? "display-none" : "",
    },
    {
      title: "REFERENCE#",
      dataIndex: "grn_id",
      render: (text, record) => {
        const firstGrns = record?.linked_grns?.[0];
        const remainingGrns = record?.linked_grns?.slice(1) || [];
        const remainingCount = remainingGrns.length;

        return firstGrns ? (
          <Tooltip
            title={
              remainingCount > 0 ? (
                <div className="tally-locations-tooltip">
                  {remainingGrns?.map((grn, index) => (
                    <Link
                      to={`/approval?type=grn&id=${grn?.grn_id}`}
                      target="_blank"
                      style={{
                        fontWeight: 600,
                        color: "#1890ff",
                        fontSize: "13px",
                        display: "block",
                        marginBottom: "4px",
                      }}
                    >
                      {grn?.grn_number}
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="tally-locations-tooltip">
                  No additional GRNs
                </div>
              )
            }
            placement="top"
            overlayInnerStyle={{ background: "white", color: "black" }}
          >
            <span>
              <Link
                to={`/purchase/goods-receiving/view/${firstGrns.grn_id}`}
                target="_blank"
              >
                {firstGrns.grn_number}
              </Link>
              <span
                style={{
                  color: "gray",
                }}
              >
                {remainingCount > 0 && ` +${remainingCount} more`}
              </span>
            </span>
          </Tooltip>
        ) : (
          <span>-</span>
        );
      },
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.REFERENCE?.visible ? "display-none" : "",
    },
    {
      title: "CREATED TIME",
      render: (text, record) => (
        <div className="min-width-100">
          <div className="column-date">
            {toISTDate(record?.created_at).format("DD/MM/YYYY hh:mm A")}
          </div>
          <H3Text
            text={
              record?.first_name
                ? `${record?.first_name} ${record?.last_name}`
                : "Unknown"
            }
            className="table-subscript"
          />
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.CREATED_TIME?.visible ? "display-none" : "",
    },
    {
      title: "AP Invoice Date",
      render: (text, record) => (
        <div className="column-date min-width-70">
          {toISTDate(record?.ap_invoice_date).format("DD/MM/YYYY")}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.AP_INOICE_DATE?.visible ? "display-none" : "",
    },
    {
      title: "AMOUNT WITHOUT TAX",
      render: (text, record) => (
        <div className="min-width-150">
          {isDataMaskingPolicyEnable && isHideCostPrice ? (
            <HideValue
              showPopOver
              popOverMessage="You don't have access to view grand total"
            />
          ) : (
            MONEY(record?.document_base_price, record?.currency_code)
          )}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.AMOUNT_WITHOUT_TAX.visible
        ? "display-none"
        : "",
    },
    {
      title: "TAXES",
      render: (text, record) => (
        <div className="min-width-50">
          {record?.seller_type === "OVERSEAS" ? "-" : MONEY(record?.gst, record?.currency_code)}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.TAXES.visible ? "display-none" : "",
    },
    {
      title: "GRAND TOTAL",
      render: (text, record) => (
        <div className="min-width-100">
          {isDataMaskingPolicyEnable && isHideCostPrice ? (
            <HideValue
              showPopOver
              popOverMessage="You don't have access to view grand total"
            />
          ) : (
            MONEY(record?.grand_total, record?.currency_code)
          )}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.GRAND_TOTAL?.visible ? "display-none" : "",
    },
    {
      title: "STATUS",
      render: (item) => (
        <div
          className="qr__status min-width-70"
          style={{
            backgroundColor: Helpers.getStatusColor(item.status).color,
          }}
        >
          {Helpers.getStatusColor(item.status).text}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.STATUS?.visible ? "display-none" : "",
    },
    {
      title: "PAYMENT STATUS",
      render: (item) => (
        <div
          style={{
            color: Helpers.getStatusColor(item?.payment_status).color,
          }}
          className="min-width-115"
        >
          {Helpers.getStatusColor(item?.payment_status).text?.toUpperCase()}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.PAYMENT_STATUS?.visible ? "display-none" : "",
    },
    {
      title: "TOTAL DUE",
      render: (text, record) => (
        <div className="min-width-85">
          {isDataMaskingPolicyEnable && isHideCostPrice ? (
            <HideValue
              showPopOver
              popOverMessage="You don't have access to view total due"
            />
          ) : (
            // MONEY(
            //   record?.grand_total -
            //     record?.total_payment_made -
            //     (record?.currency_code
            //       ? Helpers.getValueTotalInObject(
            //           record?.debit_note_info,
            //           "document_db_total"
            //         )
            //       : Helpers.getValueTotalInObject(
            //           record?.debit_note_info,
            //           "db_total"
            //         )),
            //   record?.currency_code
            // )
            MONEY((record?.grand_total - (Helpers.getValueTotalInObject(record?.debit_note_info, 'document_db_total') || Helpers.getValueTotalInObject(record?.debit_note_info, 'db_total')) - record?.total_payment_made), record?.org_currency_info?.currency_code)
          )}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.TOTAL_DUE?.visible ? "display-none" : "",
    },
    {
      title: "EWB NUMBER",
      render: (text, record) => (
        <div className="min-width-85">
          {record?.e_way_bill?.length > 0 ? (
            record?.e_way_bill?.map((item) => (
              <div>
                <a href={item?.url} target="_blank" rel="noreferrer">
                  {record?.e_way_bill_number}
                </a>
              </div>
            ))
          ) : (
            <div>{record?.e_way_bill_number}</div>
          )}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.EWB_NUMBER?.visible ? "display-none" : "",
    },
    {
      title: "ATTACHMENTS",
      render: (text, record) => (
        <div className="min-width-100">
          {record?.attachments?.map((item, index) => (
            <div>
              <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1
                }`}</a>
            </div>
          ))}
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.ATTACHMENTS?.visible ? "display-none" : "",
    },
    {
      title: "LABELS",
      render: (item) => (
        <div className="min-width-70">
          <div className="table-labels__list">
            <div>
              <Space size={[0, 8]} wrap>
                {item?.tags?.map((tag, index) => (
                  <Tag key={index} color={colorArray[index]}>
                    {tag}
                  </Tag>
                ))}
              </Space>
            </div>
          </div>
        </div>
      ),
      responsive: ["sm", "md", "lg", "xxl"],
      hidden: isMobile,
      className: !visibleColumns?.LABEL?.visible ? "display-none" : "",
    },
  ];
  if (customFieldsProps?.data?.document_custom_fields?.length) {
    const customs = customFieldsProps?.data?.document_custom_fields;
    customs
      ?.filter((item) => item?.is_active)
      ?.map((custom) => {
        apinvoiceColumnsList.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields
                customField={
                  record.custom_fields?.filter(
                    (subItem) => subItem.cf_id === custom.cf_id
                  )?.[0]
                }
              />
            </div>
          ),
          responsive: ["sm", "md", "lg", "xxl"],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible
            ? "display-none"
            : "",
        });
      });
  }
  apinvoiceColumnsList.push({
    title: "",
    key: "action",
    className: "list__actions-column",
    render: (text, record) => (
      <div className="list__actions">
        {!isPortrait && (
          <Link
            to={`/purchase/account-payable-invoice/view/${record?.ap_invoice_id}`}
          >
            <div className="list__actions-button list__actions-button-dark">
              View
            </div>
          </Link>
        )}
      </div>
    ),
    fixed: "right",
    responsive: ["sm", "md", "lg", "xxl"],
    hidden: isMobile,
  });
  return apinvoiceColumnsList.filter((item) => !item.hidden);
};

export default AccountPayableInvoiceListTableColumns;
